function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.0166 22.85C26.4261 24.1907 24.3629 25 22.1084 25C17.078 25 13 20.9706 13 16C13 11.0294 17.078 7 22.1084 7C24.3629 7 26.4261 7.80934 28.0166 9.15001C29.6071 7.80934 31.6703 7 33.9248 7C38.9552 7 43.0331 11.0294 43.0331 16C43.0331 20.9706 38.9552 25 33.9248 25C31.6703 25 29.6071 24.1907 28.0166 22.85Z",
  fill: "#ED0006"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.0166 22.8499C29.975 21.1992 31.2168 18.7429 31.2168 16C31.2168 13.2571 29.975 10.8008 28.0166 9.15005C29.6071 7.80935 31.6703 7 33.9248 7C38.9553 7 43.0332 11.0294 43.0332 16C43.0332 20.9706 38.9553 25 33.9248 25C31.6703 25 29.6071 24.1906 28.0166 22.8499Z",
  fill: "#F9A000"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.0166 22.85C29.975 21.1992 31.2168 18.7429 31.2168 16C31.2168 13.2571 29.975 10.8008 28.0166 9.15004C26.0582 10.8008 24.8164 13.2571 24.8164 16C24.8164 18.7429 26.0582 21.1992 28.0166 22.85Z",
  fill: "#FF5E00"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 55,
  height: 31,
  rx: 5.5,
  stroke: "#DFE3E6"
});

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.d92aaf91.svg";
export { ForwardRef as ReactComponent };